import(/* webpackMode: "eager" */ "/app/packages/nsp-component/src/nsp-containers.tsx");
import(/* webpackMode: "eager" */ "/app/packages/nsp/src/nsp-provider.tsx")